import { useState, useEffect } from 'react';
import { toast } from 'sonner';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      toast.success('Conexão restabelecida!', {
        description: 'Você está online novamente.',
        id: 'network-status'
      });
    };

    const handleOffline = () => {
      setIsOnline(false);
      toast.error('Sem conexão com a internet', {
        description: 'O aplicativo está funcionando em modo offline.',
        duration: Infinity,
        id: 'network-status'
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
